import React, {useRef, useState, useContext} from 'react';
import {Form, Input, Popover, Button, Image, notification, Card, Row, Col} from 'antd';
import {buttonItemLayout, formLayout} from './formLayout';
import {attaches} from './attachType';
import LinkFormModal from '../../../../component/LinkFormModal';
import MomentUploadModal from '../../../../component/MomentUploadModal';
import {addMomentTask} from '@/api/customer';
import {MinusCircleOutlined, PlusOutlined} from '@/icons';
import styles from './form.module.less';
import ReactPlayer from 'react-player';
import MsgContext from '@/page/customer/MsgPage/msgContext';

const {TextArea} = Input;

export default function MomentForm({editable = false}) {
    const {
        setCount,
        setUserIds,
        userIds,
        setNames,
        setSelectedUsers,
        images,
        setImages,
        link,
        setLink,
        videos,
        setVideos,
        viewText,
        setViewText,
    } = useContext(MsgContext);
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState('');
    const [type, setType] = useState({
        key: 'image',
        label: '图片',
        maxCount: 1,
        maxSize: 10240000, // 10m
        accept: '.png, .jpg, .jpeg',
        width: 1440,
        height: 1080,
    });
    const [key, setKey] = useState(0);
    // const [images, setImages] = useState([]);
    // const [link, setLink] = useState(null);
    // const [videos, setVideos] = useState([]);
    const formRef = useRef();
    const linkFormRef = useRef();
    const momentUploadRef = useRef();

    function renderPopoverContent() {
        return (
            <div className={styles.attachContent}>
                {attaches.map(item => (
                    <div
                        className={styles.attachBlock}
                        key={item.key}
                        onClick={() => {
                            selectType(item.key);
                        }}
                    >
                        {item.value}
                    </div>
                ))}
            </div>
        );
    }

    function selectType(selectKey) {
        if (selectKey !== key && (link || images.length > 0 || videos.length > 0)) {
            notification.warn({
                message: '附件只能选择一种',
            });
        } else {
            setKey(selectKey);
            if (selectKey === 0) linkFormRef.current.open('LINK', false);
            if (selectKey === 1) {
                setTitle('图片上传');
                const type = {
                    key: 'image',
                    label: '图片',
                    maxCount: 9,
                    maxSize: 10240000, // 10m
                    accept: '.png, .jpg, .jpeg',
                    width: 1440,
                    height: 1080,
                };
                setType(type);
                momentUploadRef.current.showModal();
            }
            if (selectKey === 2) {
                setTitle('视频上传');
                const type = {
                    key: 'video',
                    label: '视频',
                    maxCount: 1,
                    maxSize: 10240000, // 10m
                    accept: '.mp4',
                };
                setType(type);
                momentUploadRef.current.showModal();
            }
            setVisible(false);
        }
    }

    function afterUpload(data) {
        if (key === 0) {
            setLink(data);
        }
        if (key === 1) {
            const temp = [...images];
            temp.push(data[0]);
            console.log(images);
            setImages(temp);
            if (temp.length > 9) {
                notification.error({
                    message: '朋友圈图片不能超过9张',
                });
            } else {
            }
        }
        if (key === 2) {
            setVideos([data[0]]);
        }
    }

    function renderAttaches(attachType) {
        if (attachType === 'link') {
            return (
                link && (
                    <Form.Item label="链接:">
                        <div className={styles.link}>
                            <Card
                                cover={
                                    <img
                                        alt="example"
                                        src={link.imageUrl}
                                        style={{width: 200, height: 100, objectFit: 'cover'}}
                                    />
                                }
                            >
                                <Card.Meta
                                    title={link.title}
                                    description={
                                        <a href={link.url} target="_blank">
                                            {link.url}
                                        </a>
                                    }
                                />
                            </Card>
                            <MinusCircleOutlined
                                onClick={() => remove(link, attachType)}
                                className={styles.icon}
                            />
                        </div>
                    </Form.Item>
                )
            );
        }
        if (attachType === 'image') {
            return (
                images.length > 0 && (
                    <Form.Item label="图片:">
                        {
                            <Row className={styles.formAttach}>
                                {images.map((item, key) => (
                                    <Col span={8}>
                                        <div key={key} className={styles.attach}>
                                            <Image
                                                src={item.urls.file}
                                                width={200}
                                                height={100}
                                                style={{objectFit: 'cover'}}
                                            />
                                            <MinusCircleOutlined
                                                onClick={() => remove(item, attachType)}
                                                className={styles.icon}
                                            />
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        }
                    </Form.Item>
                )
            );
        }
        if (attachType === 'video') {
            return (
                videos.length > 0 && (
                    <Form.Item label="视频:">
                        {
                            <div className={styles.formAttach}>
                                {videos.map((item, key) => (
                                    <div key={key} className={styles.attach}>
                                        <ReactPlayer
                                            controls
                                            playing={false}
                                            url={item.urls.file}
                                            width={200}
                                            height={100}
                                        />
                                        <MinusCircleOutlined
                                            onClick={() => remove(item, attachType)}
                                            className={styles.icon}
                                        />
                                    </div>
                                ))}
                            </div>
                        }
                    </Form.Item>
                )
            );
        }
    }

    function remove(item, attachType) {
        if (attachType === 'link') setLink(null);
        if (attachType === 'video') setVideos([]);
        if (attachType === 'image') {
            let temp = images.filter(file => file.id !== item.id);
            setImages(temp);
        }
    }

    // 关闭弹出框后绘制页面
    function afterCloseModal() {}

    // function createLink(link) {
    //     setLink(link);
    //     // const sendData = {
    //     //     sendMomentParam: {
    //     //         text: {
    //     //             content: '测试链接',
    //     //         },
    //     //         attachments: [
    //     //             {
    //     //                 msgtype: 'link',
    //     //                 link: link,
    //     //             },
    //     //         ],
    //     //         visible_range: {
    //     //             sender_list: {
    //     //                 user_list: ['hanls', 'qianjund'],
    //     //             },
    //     //         },
    //     //     },
    //     //     sysAttaches: [],
    //     // };
    //     // addMomentTask(sendData).then(res => {
    //     //     console.log(res);
    //     // });
    // }

    function onSubmit(val) {
        let sendData = {
            sendMomentParam: {
                text: {
                    content: val.content,
                },
                attachments: [],
                visible_range: {
                    sender_list: {
                        // user_list: ['hanls', 'qianjund', 'caoweid'],
                        user_list: userIds,
                    },
                },
            },
            sysAttaches: [],
        };
        if (link && key === 0) {
            const {title, url, media_id} = link;
            sendData.sendMomentParam.attachments = [
                {
                    msgtype: 'link',
                    link: {
                        title,
                        url,
                        media_id,
                    },
                },
            ];
        } else {
            sendData.sysAttaches = [...videos, ...images];
        }
        console.log('sendData', sendData);
        addMomentTask(sendData).then(res => {
            console.log(res);
            if (res.data.errcode === 0) {
                notification.success({
                    message: '发送成功',
                });
            } else {
                notification.error({
                    message: '发送失败',
                    description: (
                        <>
                            <p>{'错误码：' + res.data.errcode}</p>
                            <a
                                href={
                                    'https://open.work.weixin.qq.com/devtool/query?e=' +
                                    res.data.errcode
                                }
                                target="_blank"
                            >
                                点击查询具体错误
                            </a>
                        </>
                    ),
                });
            }
        });
    }

    function reset() {
        init();
        setCount(0);
        setUserIds([]);
        setNames([]);
        setSelectedUsers([]);
        setViewText(null);
        formRef.current.resetFields();
    }

    function init() {
        setLink(null);
        setImages([]);
        setVideos([]);
    }

    function changeText(e) {
        setViewText(e.target.value);
    }

    return (
        <>
            <Form
                layout="vertical"
                {...formLayout}
                ref={formRef}
                onFinish={onSubmit}
                style={{margin: '20px'}}
            >
                <Form.Item label="消息内容：" name="content">
                    <TextArea rows={10} maxLength={2000} onChange={changeText} />
                </Form.Item>
                <Form.Item {...formLayout}>
                    <Popover
                        content={renderPopoverContent()}
                        title="选择附件类型「最多添加9个附件」"
                        trigger="click"
                        visible={visible}
                        onVisibleChange={visible => setVisible(visible)}
                        placement="bottomLeft"
                    >
                        <Button type="dashed" icon={<PlusOutlined />} disabled={!editable}>
                            添加附件
                        </Button>
                    </Popover>
                </Form.Item>
                {link && renderAttaches('link')}
                {images.length > 0 && renderAttaches('image')}
                {videos.length > 0 && renderAttaches('video')}
                <Form.Item {...buttonItemLayout}>
                    <Button
                        htmlType="button"
                        onClick={reset}
                        className={styles.reset}
                        disabled={!editable}
                    >
                        重置
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className={styles.submit}
                        disabled={!editable}
                    >
                        提交
                    </Button>
                </Form.Item>
            </Form>
            <LinkFormModal ref={linkFormRef} createLink={afterUpload} />
            <MomentUploadModal
                ref={momentUploadRef}
                modalTitle={title}
                type={type}
                afterUpload={afterUpload}
                afterCloseModal={afterCloseModal}
            />
        </>
    );
}
